import {
  isSmsSender,
  type Sender,
  senderAddress,
  type SenderMethod,
  senderMethod,
  type SmsSender,
} from '../types/senders'

const INBOUND_SMS_REPLY_NOTICE =
  'Ordinary replies follow Inbound settings; otherwise they are unmonitored. STOP, START and HELP are still handled.'

export const DEFAULT_SMS_REPLY_NOTICE = `The default number has no Schedule reply destination. ${INBOUND_SMS_REPLY_NOTICE}`

export function smsReplyNotice(sender: Pick<SmsSender, 'isDefault' | 'inboundApp'>): string {
  if (sender.isDefault) {
    return DEFAULT_SMS_REPLY_NOTICE
  }
  return sender.inboundApp === 'schedule'
    ? 'Reply destination: Schedule ambassador messages. STOP, START and HELP are handled separately.'
    : INBOUND_SMS_REPLY_NOTICE
}

export function smsSenderPresentation(senders: Sender[], id: string) {
  const sender = senders.find((row): row is SmsSender => isSmsSender(row) && (id ? row.id === id : row.isDefault))
  return {
    identity: sender
      ? `${sender.isDefault ? 'Default: ' : ''}${sender.nickname} (${sender.phoneNumber})`
      : id
        ? 'Selected SMS sender unavailable'
        : 'Default SMS sender unavailable',
    notice: sender
      ? smsReplyNotice(sender)
      : id
        ? 'Confirm the selected sender before sending. Its reply destination could not be verified.'
        : `${DEFAULT_SMS_REPLY_NOTICE} Check Integrations for a configured default before live sending. Sandbox capture can continue.`,
  }
}

export function senderOptions(senders: Sender[], method: SenderMethod) {
  return senders
    .filter(
      (sender) =>
        senderMethod(sender) === method &&
        sender.verified &&
        (isSmsSender(sender) ? sender.active && (!sender.locked || sender.isDefault) : !sender.locked),
    )
    .map((sender) => ({
      value: sender.id,
      label: isSmsSender(sender)
        ? `${sender.isDefault ? 'Default: ' : ''}${sender.nickname} (${senderAddress(sender)})`
        : `${sender.nickname} (${sender.fromName} <${sender.fromEmail}>)`,
    }))
}
